import React, { useEffect, useRef, useState } from "react";
import { FaPrint } from "react-icons/fa";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { config } from "../../CommonUtils/CommonUrl/CommonUrls";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios/CommonAxios";
import { useSelector } from "react-redux";
import moment from "moment";
import { useLocation } from "react-router-dom";
export default function IdCard() {
  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails);
  let userType = loginreducer?.userType;
  let navigate = useNavigate();
  let componentRef = useRef();
  // const latestTab = useSelector((state) => state.reducers.loginreducer.tabdetails.latestTab);
  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "ID-Print",
  });
  const [showData, setData] = useState([])
  const [showQrCode, setQrCode] = useState([])
  const location = useLocation();
  function getDataFunction() {

    const { userId } = location.state || {}; // retrieve the ID

    console.log("User ID:", userId);


    const usr_id = userType === 'emp' ? userId : loginreducer?.loginData?.usr_id


    let url = config.url.BOC_URL + "worker-id?userId=" + usr_id;
    CommonAxiosGet(url).then((response) => {
      if (response.data.status === true) {
        const workerData = response.data.workerReg[0];
        const familyDetails = JSON.parse(workerData.fam_details || "[]");
        workerData.fam_details = familyDetails;
        setData(workerData);
        setQrCode(response?.data?.qrcode);
      } else {
        setData([]);
        setQrCode([]);
      }
    });
  }

  useEffect(() => {
    getDataFunction();
  }, [])

  return (
    // <PublicHeader/>
    //   <div className="main_section">  </div>
    //     <jnb.Container className="mt-1">
    //     <jnb.Row>
    //                   <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between px-0">
    // <div className="inner-herbpage-service-title1">
    //                         <h1>Payment Details </h1>
    //                     </div>
    //                       <div className="text-right">
    //                     <button className="btn btn-secondary btn-sm" onClick={() => { navigate('/WorkerRegistrationForm') }}>Back</button>
    //                     </div>
    //                     </jnb.Col>
    //                     </jnb.Row>
    //                     </jnb.Container>
    <div className=" id-card-print d-flex flex-column align-items-center justify-content-center" ref={componentRef}
      style={{ height: "100vh" }}>
      {/* <div className="p-0 mt-0"> */}
      {/* <div className="page-wrapper"> */}
      {/* <div className="text-center my-3 no-print flex d-flex justify-content-end">
        <b>Click Here</b> <FaHandPointRight size={24} />{" "}
        <button className="btn btn-primary ms-2" onClick={handleprint}>
          Print <FaPrint style={{ fontSize: "18px" }} />
        </button>
      </div> */}
      <div>
        <div className=" pt-4 no-print flex d-flex justify-content-end pb-4">
          <div className="text-right">
            <button className="btn btn-secondary btn-md"

              onClick={() => {
                navigate(-1);
              }}
            >Back</button>
          </div> &nbsp;&nbsp;
          {/* <b  className="pt-2"> Click Here &nbsp; </b> <FaHandPointRight size={28} />&nbsp; */}
          <button className="btn btn-primary" variant="primary" onClick={handleprint}>Print&nbsp;
            <FaPrint title="Print" style={{ fontSize: '22px' }} />
          </button>
        </div>
      </div>
      {/* <div className="flex d-flex justify-content-center " style={{alignItems: "center",height: "90vh"}}> */}
      <div className="id-card-container">
        {/* Left Panel */}
        <div className="left-panel" style={{ border: "1px solid black" }}>
          <div
            className="bg-overlay"
            style={{
              backgroundImage: "url('/images/logo.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "40%", // smaller logo for left
              opacity: 0.2,
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: "100%",
              zIndex: 0,
            }}
          ></div>
          <div className="header">
            <img src="/images/logo.png" alt="Logo" className="logo " />
            <div>
              <h4 className="board-name">
                Andhra Pradesh Building and Other <br />
                Construction Workers Welfare Board
              </h4>
              <div className="reg-no">{showData?.registration_no}</div>
            </div>
          </div>
          <div className="details-photo-wrap">
            {/* <div className="details">
            <div><strong>Name</strong>: Shaik Mahesh</div>
            <div><strong>Father/Husband Name</strong>: Saidulu</div>
            <div><strong>Occupation</strong>: Mason Cooli</div>
            <div><strong>Phone No.</strong>: XXXXXX5377</div>
            <div><strong>DOB</strong>: 01-07-1992</div>
            <div><strong>Aadhaar No.</strong>: XXXXXXXX8787</div>
            <div><strong>Date of Reg.</strong>: 03-03-2023</div>
          </div> */}
            <div className="details">
              <div className="person-details">
                <p className="label">Name</p>
                <p className="value"><span className="colon">:</span> {showData?.first_name} {showData?.last_name}</p>
              </div>
              <div className="person-details">
                <p className="label">Father/Husband Name</p>
                <p className="value"><span className="colon">:</span>{showData?.father_name}</p>
              </div>
              <div className="person-details">
                <p className="label">Occupation</p>
                <p className="value"><span className="colon">:</span>{showData?.type_of_work}</p>
              </div>
              <div className="person-details">
                <p className="label">Phone No</p>
                <p className="value"><span className="colon">:</span>{showData?.phone_no}</p>
              </div>
              <div className="person-details">
                <p className="label">DOB</p>
                <p className="value"><span className="colon">:</span>{moment(showData?.dob).format("DD-MM-YYYY")}</p>
              </div>
              <div className="person-details">
                <p className="label">Aadhaar No</p>
                <p className="value"><span className="colon">:</span>{showData?.mask_aadhaar}</p>
              </div>
              <div className="person-details">
                <p className="label">Date of Reg</p>
                {/* <p className="value"><span className="colon">:</span>{moment(new Date(showData?.entry_dt).toLocaleDateString("en-CA")).format("DD-MM-YYYY")}</p> */}
                <p className="value"><span className="colon">:</span>{moment(showData?.registration_date).format("DD-MM-YYYY")}</p>
              </div>
              <div className="person-details">
                <p className="label">valid until</p>
                <p className="value"><span className="colon">:</span>{moment(showData?.valid_date).format("DD-MM-YYYY")}</p>
              </div>
            </div>
            <img src={config.url.FILE_DOWNLOAD_URL + showData.upload_photo} alt="Profile" className="profile-photo mt-4" />
          </div>
        </div>
        &nbsp;&nbsp;
        {/* Right Panel */}
        <div className="right-panel" style={{ border: "1px solid black" }}>
          <div
            className="bg-overlay"
            style={{
              backgroundImage: "url('/images/logo.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "60%", // larger logo for right
              opacity: 0.2,
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: "100%",
              zIndex: 0,
            }}
          ></div>
          <div className="address">
            <span className="address-title">Address</span><br />
            {showData?.present_door_no},<br />
            {showData?.present_district},<br />
            {showData?.present_mandal},<br />
            {showData?.present_village},<br />
            {showData?.present_address},<br />
            {showData?.present_pincode}
          </div>
          <div className="officer-section">
            <div className="officer-info">
              <img src={config.url.FILE_DOWNLOAD_URL + showData.alo_remarks} alt="Signature" className="signature" /><br />
              <strong>Registering Officer</strong><br />
              <strong> Asst. Labour Officer</strong><br />
              <strong> Guntur - II</strong>
            </div>
          </div>
          <div className="bottom-section">
            <img src={`data:image/png;base64,${showQrCode}`} alt="QR Code" className="qr-code mt-0 pb-3" style={{ height: "70px" }} />
            <div className="note mt-0 pt-2">
              గమనిక: ప్రతి సంవత్సరం లేదా 5 సంవత్సరాలకు ఒకసారి<br />
              ఏప్రిల్ 20 లోగా నూతనీకరణ చేయించుకోవాలి
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
    </div>
    // </div>
  );
}
